<!-- Audience Network interstitial -->
<div class="anp ani">
  <div class="mst">
    <div class="mst-screen ani-screen">
      <app-meta-creative class="mst-creative" [src]="data.creative" [kind]="data.creativeKind" slot="story"></app-meta-creative>
      <div class="mst-scrim"></div>
      <div class="ani-scrim"></div>

      <div class="ani-header">
        <i class="bi bi-x-lg ani-close"></i>
        <img class="ani-avatar" [src]="avatar" alt="" />
        <div class="ani-identity">
          <div>{{ pageName }}</div>
          <div>Oglas</div>
        </div>
        <i class="bi bi-info-circle ani-icon"></i>
        <i class="bi bi-play ani-icon ani-choices"></i>
      </div>

      <a class="anp-link ani-copy" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
        <div class="ani-headline">{{ headline }}</div>
        <div class="ani-text">{{ primaryText }}</div>
        <span class="ani-cta">{{ cta }}</span>
      </a>
    </div>
  </div>

  <div class="anp-note">
    <p class="anp-note-lead">Ads on the Audience Network are shown in third-party mobile apps and mobile websites.</p>
    <p>Please note, this is only a preview. The ad may show up differently in other apps and websites.</p>
    <p *ngIf="data.creativeKind === 'image'">Images may animate to reveal the entire image.</p>
  </div>
</div>
